/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const NETWORK_FIELD_KEYS = {
  vpc: 'network.vpc',
  subnet: 'network.subnet',
  securitygroup: 'network.securitygroup',
  staticIpv4: 'network.staticIpv4',
} as const;

export const NETWORK_FIELD_KEY_LIST = [
  NETWORK_FIELD_KEYS.vpc,
  NETWORK_FIELD_KEYS.subnet,
  NETWORK_FIELD_KEYS.securitygroup,
  NETWORK_FIELD_KEYS.staticIpv4,
] as const;

export const NETWORK_OPTION_META_KEYS = {
  vpc: 'vpc',
  subnet: 'subnet',
  securitygroup: 'securitygroup',
};
